import { render } from "./EntranceExamStepsSection.vue?vue&type=template&id=d9d21be8&scoped=true"
import script from "./EntranceExamStepsSection.vue?vue&type=script&lang=js"
export * from "./EntranceExamStepsSection.vue?vue&type=script&lang=js"

import "./EntranceExamStepsSection.vue?vue&type=style&index=0&id=d9d21be8&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d21be8"]])

export default __exports__